<template>
  <div class="global-chat-active-chat-messages-container__message" v-bind:class="{actionable: canActOnMessage}" v-if="message.visible">
    <span v-waypoint="{ active: true, callback: wayPointPassed }" v-if="waypoint"></span>
    <span v-waypoint="{ active: true, callback: bottomWayPointPassed }" v-if="bottomWaypoint"></span>
    <GlobalChatAvatarBubble
      v-bind:class="{'global-chat-active-chat-messages-container__avatar-currrent': myMessage}"
      v-bind:first-name="eventAttendee.attendee_fields.first_name"
      v-bind:last-name="eventAttendee.attendee_fields.last_name"
      v-bind:avatar="eventAttendee.attendee_fields.user_avatar_url_medium"
      v-bind:online="this.online"
      v-bind:can-moderate="this.moderator"
      v-bind:show-status="false"
    >
    </GlobalChatAvatarBubble>

    <div v-if="message.pinned">
      <div class="global-chat-active-chat-pinned-message-container__bubble">
        <div class="global-chat-active-chat-messages-container__header">
          <div class="member-name">
            {{eventAttendee.attendee_fields.first_name}} {{eventAttendee.attendee_fields.last_name}}
            <span class='pinned-message-icon' :class="{'global-chat-admin': canModerate}">
              <i tabindex="0" @keydown.enter="emitPinMessage('unpin')" v-on:click="emitPinMessage('unpin')" class="fas fa-thumbtack"></i>
            </span>
          </div>
          <span class='created-at'>{{ this.createdAtFormatted }}</span>
        </div>
        <div class="global-chat-active-chat-messages-container__content-text"  v-html="sanitizeMessage(message.message)"></div>
      </div>
    </div>

    <div class="global-chat-active-chat-messages-container__bubble"
      aria-label="Chat Message"
      tabindex="0"
      v-on:click="toggleSelected()"
      @keydown.enter="toggleSelected()"
      v-bind:class="{'global-chat-active-chat-messages-container__bubble-selected': isSelected}"
    >
      <div class="global-chat-active-chat-messages-container__header">
        <div class="member-name">
          {{eventAttendee.attendee_fields.first_name}} {{eventAttendee.attendee_fields.last_name}}
          <span class='blocked-text-span-message' v-if="blockedAttendee">
            {{lang.get('event_strings.global-chat.blocked_label')}}
          </span>
        </div>
        <span class='created-at'>{{ this.createdAtFormatted }}</span>
      </div>
      <div class="global-chat-active-chat-messages-container__content-text"  v-html="sanitizeMessage(message.message)"></div>
    </div>

    <div class="global-chat-active-chat-messages-container__actions"  v-if="isSelected">
      <i v-on:click="toggleMenuExpanded()" @keydown.enter="toggleMenuExpanded()" class="fas fa-ellipsis-v action-expand-btn" aria-label="Actions" tabindex="0"></i>
      <div class='message-action-card' v-if="menuExpanded">
        <i
          v-if="!this.attachedChat && !this.myMessage && this.allowsDirectMessage"
          v-on:click="emitDirectMessage()" 
          @keydown.enter="emitDirectMessage()" 
          class="fas fa-comment-dots"
          aria-label="Direct Message"
          tabindex="0"
          >
        </i>
        
        <!-- Blocked attendee -->
        <i
          v-if="!this.attachedChat && !this.myMessage && !this.blockedAttendee"
          aria-label="Block Attendee"
          tabindex="0"
          v-on:click="emitToggleBlockConnection()" 
          @keydown.enter="emitToggleBlockConnection()"
          class="far fa-minus-circle"
          >
        </i>

        <!-- unblock attendee  -->

        <i
          v-if="!this.attachedChat && !this.myMessage && this.blockedAttendee"
          aria-label="Unblock Attendee"
          tabindex="0"
          v-on:click="emitToggleBlockConnection()" 
          @keydown.enter="emitToggleBlockConnection()"
          class="fas fa-minus-circle"
          >
        </i>

        <div class="d-flex" v-if="canModerate">
          <i aria-label="Pin Message" tabindex="0" v-if="!message.pinned" @keydown.enter="emitPinMessage('pin')" v-on:click="emitPinMessage('pin')" class="fas fa-thumbtack"></i>
          <i aria-label="Delete Message" tabindex="0" @keydown.enter="emitFlagMessage()" v-on:click="emitFlagMessage()" class="fas fa-trash"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import sanitizeHtml from 'sanitize-html';
import GlobalChatAvatarBubble from './GlobalChatAvatarBubble.vue';


export default {

  components: {
    GlobalChatAvatarBubble
  },

  props: ['currentEventAttendee', 'message', 'selectedMessage', 'room', 'waypoint', 'bottomWaypoint', 'moderator', 'blockedByConnections'],

  data: function () {
    return {
      selected: false,
      menuExpanded: false
    }
  },

  computed: {

    attachedChat: function () {
      return !!this.room.chattable_id
    },

    blockedAttendee: function () {
      return this.blockedByConnections && this.blockedByConnections.length
    },

    eventAttendee: function () {
      return this.message.event_attendee
    },

    allowsDirectMessage: function () {
      return this.eventAttendee.attendee_fields.allow_direct_messages
    },

    directMessage: function () {
      return !!this.message.recipient_id
    },

    myMessage: function () {
      return this.message.event_attendee_id == this.currentEventAttendee.id
    },

    canModerate: function () {
      return this.room && this.room.can_moderate
    },

    canActOnMessage: function () {
      return !this.directMessage && (this.room.can_moderate || !this.myMessage)
    },

    online: function () {
      return this.eventAttendee.online
    },
    
    createdAtFormatted: function () {
      if (!this.message.created_at_moment) return '';
      var now = new moment()
      if (!now.isSame(this.message.created_at_moment, 'day')) {
        return this.message.created_at_moment.fromNow()
        // return this.message.created_at_moment.format('M[/]D [at] hh:mm A')
      }
      return this.message.created_at_moment.format('hh:mm A')
    },

    isSelected: function () {
      if (this.selectedMessage) {
        return this.selectedMessage.id == this.message.id
      }
      return false
    }
  },

  watch: {
    isSelected: function () {
      if (!this.isSelected) this.menuExpanded = false
    }
  },

  methods: {

    sanitizeMessage: function (message) {
      return sanitizeHtml(message)
    },

    toggleMenuExpanded: function () {
      this.menuExpanded = !this.menuExpanded
    },

    toggleSelected () {
      // cant message or block self
      if (!this.canActOnMessage) return;
      this.$root.$emit('select-message', this.message)
      window.EventBus.$emit('select-message', this.message)
    },

    emitDirectMessage () {
      this.$root.$emit('direct-message-from-message', this.message)
    },

    emitToggleBlockConnection: function () {
      this.$root.$emit('toggle-blocked-connection-from-message', this.message)
    },

    emitPinMessage (action) {
      if (!this.canModerate) return
      this.message.action = action
      this.$root.$emit('pin-message', this.message)
      window.EventBus.$emit('pin-message-minimal-chat', {
        message: this.message,
        roomId: this.room.id
      })
    },

    emitFlagMessage () {
      this.$root.$emit('flag-message', this.message)
      window.EventBus.$emit('flag-message', this.message)
    },

    wayPointPassed: function (e) {
      if (e.direction == 'bottom') {
        this.$root.$emit('get-more-messages',  this.room.id)
      }
    },

    bottomWayPointPassed: function (e) {

       if (e.direction == 'top') {
         this.$root.$emit('scrolled-below-message-waypoint')
         window.EventBus.$emit('scrolled-below-message-waypoint', {
           room: this.room
         })
       }
       if (e.direction == 'bottom') {
         this.$root.$emit('scrolled-above-message-waypoint')
         window.EventBus.$emit('scrolled-above-message-waypoint', {
           room: this.room
         })
       }
    },
  }
};
</script>

<style scoped>
  .action-expand-btn {
    position: relative;
  }

  .message-action-card {
    position: absolute;
    right: 0;
    bottom: 41px;
    padding: 1rem;
    display: flex;
    justify-content: space-around;
    cursor: pointer;
    padding: 0.3rem 0rem;
    box-shadow: 0px 1px 1px 3px rgb(204 204 204 / 70%);
    margin-top: 0.4rem;
    margin-right: 0.8rem;
    background-color: white;
    border-radius: 0.3rem;
  }

  .message-action-card i {
    padding: 0.2rem 0.5rem;
  }

</style>